<script>
import TgTooltip from "@/abc-dsk/components/Tooltip/TgTooltip.vue";
import IconGreenInfo from "@/components/icons/green/IconGreenInfo.vue";
import IconWhiteInfo from "@/components/icons/white/IconWhiteInfo.vue";

export default {
  name: "ArticleTooltip",
  components: {
    IconGreenInfo,
    IconWhiteInfo,
    TgTooltip
  },
  props: {
    text: {
      type: String,
      required: true
    },
    variant: {
      type: String,
      default: "primary"
    }
  },
  data() {
    return {
      open: false
    };
  }
};
</script>

<template>
  <TgTooltip
    :tooltip-container-class="`info-tooltip info-tooltip--${variant}`"
    :tooltip-content-class="`tooltip-inner info-tooltip__inner info-tooltip__inner--${variant}`"
    :tooltip-arrow-class="`tooltip-arrow info-tooltip__arrow info-tooltip__arrow--${variant}`"
    :margin-bottom="-5"
    :text="text"
    @show="open = true"
    @hide="open = false"
  >
    <IconWhiteInfo
      v-if="open"
      class="info-tooltip__icon"
      :icon-class="`icon-${variant}-stroke`"
      aria-hidden="true"
    ></IconWhiteInfo>
    <IconGreenInfo
      v-else
      class="info-tooltip__icon"
      :icon-class="`icon-${variant}-fill`"
      aria-hidden="true"
    ></IconGreenInfo>
    <template #popover>
      {{ text }}
    </template>
  </TgTooltip>
</template>
